import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import getDemoActionsCellContent from './demoRowActions';

// Dummy list-item type for the gallery grids. Mirrors the static-metadata
// contract of real item classes (UserItem, ThirdPartyJobPaymentsItem etc.):
// copying constructor, NameOfTheIdField()/nameOfTheItemDetailList(), the
// FieldsToShowInDataTable() descriptor method, MoneyFields + Currency()
// (which returns the NAME of the currency-code field on the item),
// DateFields/DateOnlyFields/BoolFields, detail tabs (FieldsToShowInListTable)
// and serviceFunctionForListTable.
export default class DemoListItem {
  ShopId = 0;
  ShopName = '';
  City = '';
  Status = '';
  VisitDate = '';
  Fee = 0;
  IsActive = true;
  CurrencyCode = 'USD';

  // TabListTable re-instantiates the item after serviceFunctionForListTable
  // resolves (new type(result)), so the constructor must copy an optional raw item.
  constructor(item?: any) {
    if (item !== undefined && item !== null) {
      Object.assign(this, item);
    }
  }

  static NameOfTheIdField() {
    return 'ShopId';
  }

  static nameOfTheItemDetailList(item: DemoListItem) {
    return `Demo Shop - ${item.ShopName} (${item.ShopId})`;
  }

  static MoneyFields = ['Fee'];

  // Returns the name of the item field that holds the currency code
  // (DataTableBody renders item[type.Currency()]), NOT a currency literal.
  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary: string[] = [];

  static CurrencySecondary() {
    return '';
  }

  // DateFields drives grid formatting; DateOnlyFields drives the detail tabs
  // (same double-listing as ThirdPartyJobPaymentsItem.JobDate).
  static DateFields = ['VisitDate'];
  static DateOnlyFields = ['VisitDate'];
  static BoolFields = ['IsActive'];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'ID',
        orderById: 'ShopId',
        data: 'ShopId',
        type: FieldTypesEnum.DataFieldWithDetails,
        tableminWidth: '70px',
      },
      { label: 'Shop', orderById: 'ShopName', data: 'ShopName', type: FieldTypesEnum.PureDataField },
      { label: 'City', orderById: 'City', data: 'City', type: FieldTypesEnum.PureDataField },
      { label: 'Status', orderById: 'Status', data: 'Status', type: FieldTypesEnum.PureDataField },
      { label: 'Visit Date', orderById: 'VisitDate', data: 'VisitDate', type: FieldTypesEnum.PureDataField },
      { label: 'Fee', orderById: 'Fee', data: 'Fee', type: FieldTypesEnum.PureDataField },
      { label: 'Active', orderById: '', data: 'IsActive', type: FieldTypesEnum.PureDataField },
      { label: 'Actions', orderById: '', data: getDemoActionsCellContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-store',
      data: [
        { name: 'ShopName', label: 'Shop' },
        { name: 'City', label: 'City' },
        { name: 'Status', label: 'Status' },
        { name: 'VisitDate', label: 'Visit Date' },
        { name: 'Fee', label: 'Fee' },
        { name: 'IsActive', label: 'Active' },
      ],
    },
  ];

  static serviceFunctionForListTable = (item: DemoListItem) => Promise.resolve(item);
}
